import type { CalculationResult } from '@mortality/core';

interface HistoryPanelProps {
  history: CalculationResult[];
  onClear: () => void;
}

const formatTimestamp = (date: Date) => {
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export function HistoryPanel({ history, onClear }: HistoryPanelProps) {
  return (
    <section className="panel full-width" aria-labelledby="history-heading">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2 id="history-heading" className="section-title">Recent Calculations</h2>
        <button className="button-secondary" type="button" onClick={onClear} disabled={!history.length}>
          Clear history
        </button>
      </div>
      {history.length === 0 ? (
        <div className="history-empty">Run a calculation to populate this space.</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Conditions</th>
                <th>Risk</th>
              </tr>
            </thead>
            <tbody>
              {history.slice(0, 12).map(entry => (
                <tr key={entry.id}>
                  <td>{formatTimestamp(entry.timestamp)}</td>
                  <td>{entry.age}</td>
                  <td>{entry.gender}</td>
                  <td>{entry.selectedConditions.length}</td>
                  <td>{entry.riskLevel ?? 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
